import { api } from '../api/client';

export type DayPoint = {
  /** ISO date, one entry per day that had trials. */
  day: string;
  trials: number;
  correct: number;
  /** Right first time, as a whole percentage of that day's trials. */
  percent: number;
  /** Average time to answer in milliseconds, as timed in the browser. Null when not measured. */
  averageMs: number | null;
  /** How many of that day's trials were run with errorless help. */
  helped: number;
};

export type MasteryStatus = {
  /** False when the account has not switched mastery rules on. */
  on: boolean;
  percentNeeded: number;
  daysNeeded: number;
  minTrialsPerDay: number;
  /** Days running, counting back, that met the bar. */
  daysMet: number;
  met: boolean;
  alreadyMaintenance: boolean;
};

export type ProgressView = {
  programId: string;
  programName: string;
  learnerId: string;
  days: number;
  totalTrials: number;
  totalCorrect: number;
  teaching: DayPoint[];
  probes: DayPoint[];
  mastery: MasteryStatus;
};

export async function fetchProgress(programId: string, days = 30): Promise<ProgressView> {
  return api<ProgressView>(
    `/progress?programId=${encodeURIComponent(programId)}&days=${days}`,
    { token: true },
  );
}

/** "15 Sep" — short enough for an axis, unambiguous about which day. */
export function shortDay(iso: string): string {
  const d = new Date(`${iso}T00:00:00Z`);
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', timeZone: 'UTC' });
}
